import React from 'react';
import loading from './loading.gif';

const Spinner = () => {
  return (
    <div className="text-center py-4" role="status">
      <img src={loading} alt="" />
      <span className="visually-hidden">Loading news…</span>
    </div>
  );
};

export default Spinner;
